// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'comments',
  standalone: false,
})
export class CommentsFormatPipe implements PipeTransform {
  transform(comments: string): string {
    return comments?.replace(/\n\r?/g, '<br />');
  }
}
